import ProcedureTriggersSettings from '@/pages/settings/procedure-triggers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/procedure-triggers'
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <ProcedureTriggersSettings />;
}
